var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start align-center mt-1"},[_c('BaseActionsButton',{attrs:{"id":"editCompanyShift","name":"editCompanyShift","iconName":"mdi-pencil","iconColor":"primary","customClass":"mr-2","tooltipMessage":"Edit Details"},on:{"click":function($event){return _vm.editCompanyShift()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }